export const iconFontAwesomeNatureBugs = (
	<i className="fa-solid fa-bugs"></i>
);
